import Field from "@/includes/fields/Field";
import {Formulario} from "@/includes/Formulario";

export default {
    createVueModelsForVue(fields: Array<Field>) {
        return fields?.reduce((carry, field) => {
            return {...carry, [field?.name]: field}
        }, {});
    },
    formatToJSON(formulario: Formulario) {
        return {
            title: formulario.title,
            fields: formulario.fields.map(field => {
                return {label: field.label, value: field.getValue()}
            })
        }
    }
}